import { z } from 'zod';
import {
  storageOfferStatusValues,
  storageOffersProductTypeValues,
} from 'src/apis/storage/mappings';
import { getPaginationSchema } from 'src/components/form/zod-schemas';
import { preprocessAsArray } from 'src/components/form/zod-utilities';
import { ssoOptionSchema } from 'src/pages/storage/locations-new/components/sso-searchable-multi-select';

export function getStorageOffersPageParamsSchema() {
  return z
    .object({
      offerName: z.string().nullable().default(null),
      offerBusinessId: z
        .string()
        .regex(/^(STO-\d+)$/, '{label} must start from "STO-".')
        .nullable()
        .default(null),
      locationName: z.string().nullable().default(null),
      ssoOrganisationId: z.preprocess(
        preprocessAsArray,
        z.array(ssoOptionSchema).default([])
      ),
      typeOfProduct: z.preprocess(
        preprocessAsArray,
        z.array(z.enum(storageOffersProductTypeValues)).default([])
      ),
      productRuntimeStart: z.string().nullable().default(null),
      productRuntimeEnd: z.string().nullable().default(null),
      offerStatus: z.preprocess(
        preprocessAsArray,
        z.array(z.enum(storageOfferStatusValues)).default([])
      ),
    })
    .merge(getPaginationSchema());
}
